var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShapes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 362,
    viewBox: "0 0 338 362",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8bidvfpcna)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M270.256 193.666c-3.518 18.658-5.253 37.708-.237 56.836 7.402 28.133-4.272 46.096-14.448 52.147-10.175 6.052-25.473 13.389-56.59.518-31.117-12.872-49.709 1.081-56.509 3.963-6.799 2.882-47.701 16.728-72.197-9.364-24.495-26.091-25.074-57.105-1.418-75.813 11.172-8.836 16.815-23.376 20.159-37.26 2.828-11.746 3.77-24.506 7.795-35.81 3.793-10.695 12.746-18.883 22.865-23.489 6.568-2.99 13.625-3.744 20.511-5.816 7.544-2.275 14.43-6.13 20.612-10.759 10.582-7.913 19.006-18.17 29.185-26.465 10.064-8.209 21.141-15.432 33.64-19.773 9.483-3.29 20.208-4.378 30.324-1.064 29.034 9.542 30.608 41.036 28.783 65.042-1.749 23.043-8.258 44.77-12.464 67.119l-.011-.012z",
    fill: "#FF5B58"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M258.812 198.66c-7.868 17.938-14.034 36.686-13.433 57.079.887 29.993-14.996 45.347-26.63 49.068-11.634 3.721-28.716 7.545-57.008-12.618s-50.221-10.452-57.726-9.134c-7.504 1.319-51.836 5.741-70.403-26.174-18.567-31.915-11.949-63.227 16.174-76.541 13.283-6.289 22.33-19.596 28.915-32.776 5.57-11.152 9.479-23.759 16.15-34.189 6.296-9.871 17.197-16.023 28.438-18.304 7.296-1.482 14.566-.6 21.97-1.085 8.111-.536 15.929-2.813 23.217-6.031 12.475-5.497 23.324-13.853 35.483-19.829 12.023-5.915 24.834-10.605 38.407-12.067 10.297-1.107 21.331.29 30.73 5.97 26.972 16.332 21.243 48.358 13.836 72.066-7.108 22.759-18.695 43.089-28.098 64.57l-.022-.005z",
    stroke: "#FF5B58",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "8bidvfpcna"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(18.199 46.252 288.773)",
    d: "M0 0h257.471v296.182H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapes);
export default __webpack_public_path__ + "static/media/shapes.68d55a7aac9f5a2f57ee04dea02e96ae.svg";
export { ForwardRef as ReactComponent };